export default __webpack_public_path__ + "static/media/hash_card.c2982733.png";